import { render, staticRenderFns } from "./AuthorizedActionsInstitution.vue?vue&type=template&id=7802a816&scoped=true"
import script from "./AuthorizedActionsInstitution.vue?vue&type=script&lang=js"
export * from "./AuthorizedActionsInstitution.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedActionsInstitution.vue?vue&type=style&index=0&id=7802a816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7802a816",
  null
  
)

export default component.exports